export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Berbagi",
    "wre-dashboard.nav-menu.item.backups": "Cadangan",
    "wre-dashboard.nav-menu.item.machines": "Mesin",
    "wre-dashboard.nav-menu.item.account": "Akun",
    "wre-dashboard.search.input.hint": "Pencarian",
    "wre-dashboard.search.label.breadcrumb": "Hasil pencarian",
    "wre-dashboard.search.message.empty": "Tidak ada item yang cocok dengan pencarian Anda",
    "wre-dashboard.side-bar.selected.title:plural": "{count} item dipilih | {count} item dipilih",
    "wre-dashboard.side-bar.backup-type.disk": "Disk",
    "wre-dashboard.side-bar.backup-type.file": "File",
    "wre-dashboard.side-bar.backup-type.notarized": "File dan folder yang dinotarisasikan",
    "wre-dashboard.side-bar.backup-type.exchange": "Aplikasi - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Aplikasi - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Aplikasi - Keadaan sistem",
    "wre-dashboard.side-bar.backup-type.application": "Aplikasi",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} tersisa",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} digunakan",
    "wre-dashboard.space-indicator.label.unlimited": "Nirbatas",
    "wre-dashboard.backups-table.column.name": "Nama",
    "wre-dashboard.backups-table.column.size": "Ukuran",
    "wre-dashboard.backups-table.column.version": "Cadangan terakhir",
    "wre-dashboard.backups-table.message.no-backups": "Belum ada cadangan dalam Awan",
    "wre-dashboard.backups-sidebar.label.size": "Ukuran",
    "wre-dashboard.backups-sidebar.label.type": "Jenis",
    "wre-dashboard.backups-sidebar.label.version": "Versi terakhir",
    "wre-dashboard.backups-sidebar.label.created": "Dibuat",
    "wre-dashboard.backups-sidebar.label.machine": "Mesin",
    "wre-dashboard.backups-sidebar.label.owner": "Pemilik",
    "wre-dashboard.content-table.column.name": "Nama",
    "wre-dashboard.content-table.column.versions": "Versi",
    "wre-dashboard.content-table.column.volumes": "Volume",
    "wre-dashboard.content-table.column.path": "Jalur",
    "wre-dashboard.content-table.column.size": "Ukuran",
    "wre-dashboard.content-table.column.version": "Versi terakhir",
    "wre-dashboard.content-table.action.versions": "Versi",
    "wre-dashboard.content-table.action.restore": "Unduh",
    "wre-dashboard.content-table.action.share": "Bagikan tautan",
    "wre-dashboard.content-table.label.size": "Ukuran",
    "wre-dashboard.content-table.label.created": "Dibuat",
    "wre-dashboard.content-table.label.modified": "Dimodifikasi",
    "wre-dashboard.content-table.message.empty-folder": "Folder ini kosong",
    "wre-dashboard.password-dialog-box.title.backup": "Cadangan terenkripsi",
    "wre-dashboard.password-dialog-box.title.archive": "Arsip terenkripsi",
    "wre-dashboard.password-dialog-box.message.backup": "Silakan tentukan kata sandi untuk mengakses cadangan {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Silakan tentukan kata sandi untuk mengakses arsip {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Kata sandi",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Kata sandi salah",
    "wre-dashboard.form.button.open": "Buka",
    "wre-dashboard.form.button.close": "Tutup",
    "wre-dashboard.form.button.cancel": "Batalkan",
    "wre-dashboard.form.button.delete": "Hapus",
    "wre-dashboard.shared-content-table.column.name": "Nama",
    "wre-dashboard.shared-content-table.column.location": "Lokasi",
    "wre-dashboard.shared-content-table.column.source": "Sumber",
    "wre-dashboard.shared-content-table.column.days": "Hari",
    "wre-dashboard.shared-content-table.column.downloads": "Unduh",
    "wre-dashboard.shared-content-table.column.shared": "Dibagikan pada",
    "wre-dashboard.shared-content-table.label.shared": "Dibagikan pada",
    "wre-dashboard.shared-content-table.label.backup": "Sumber",
    "wre-dashboard.shared-content-table.action.share": "Bagikan tautan",
    "wre-dashboard.shared-content-table.action.settings": "Pengaturan tautan",
    "wre-dashboard.shared-content-table.action.delete": "Hapus tautan",
    "wre-dashboard.shared-content-table.action.delete-selected": "Hapus tautan",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} bebas dari {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Ruang tak terbatas",
    "wre-dashboard.account-page.button.sign-out": "Keluar",
    "wre-dashboard.account-page.button.manage-subscription": "Kelola lisensi",
    "wre-dashboard.account-page.message.subscription.active": "Lisensi Anda untuk ruang {brandName} berakhir pada",
    "wre-dashboard.account-page.message.subscription.trial": "Uji coba {brandName} aktif hingga",
    "wre-dashboard.account-page.message.subscription.expired": "Lisensi Anda untuk ruang {brandName} kedaluwarsa pada",
    "wre-dashboard.account-page.message.worm-status.storage-full": "Penyimpanan {brandName} Anda penuh. Anda tidak dapat mencadangkan atau mengarsip data ke Awan.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Kurang dari {percent} persen gratis. Anda tidak akan bisa menggunakan {brandName} nanti.",
    "wre-dashboard.versions-dialog-box.title": "Versi {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Salin tautan",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Pengaturan tautan",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Siapa pun dengan tautan ini dapat menampilkan versi data terbaru",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Dibagikan pada {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Tautan yang Disalin",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Kesalahan Salinan Tautan",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Hapus tautan",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Tautan ini tidak lagi berfungsi untuk siapa pun yang memilikinya",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Hapus tautan",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Tautan ini akan berhenti berfungsi untuk siapa pun yang memilikinya",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Pengaturan tautan",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Hapus tautan",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Selesai",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Kata sandi",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Atur ulang kata sandi",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Proteksi kata sandi",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Lindungi tautan ini dengan menggunakan kata sandi",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Kedaluwarsa",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Batas unduhan",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Nonaktifkan tautan ini dalam {splitMarker} hari | Nonaktifkan tautan ini dalam {splitMarker} hari",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Nonaktifkan tautan ini setelah {splitMarker} unduhan | Nonaktifkan tautan ini setelah {splitMarker} unduhan",
    "wre-dashboard.sub-accounts-dialog-box.title": "Akun",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Pencarian",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Tidak ada item yang cocok dengan pencarian Anda",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Nama",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Penggunaan",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Cadangan terakhir",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Kedaluwarsa",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} bebas dari {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Volume langganan",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Kedaluwarsa",
    "wre-dashboard.machines-table.column.name": "Nama",
    "wre-dashboard.machines-table.column.size": "Ukuran",
    "wre-dashboard.machines-table.message.no-machines": "Belum ada mesin dalam Awan"
};
